var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavTradesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "5 5 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_7569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.25 20.03C24.25 20.57 24.4 20.65 24.74 20.77L25.25 20.95V19.25H24.95C24.57 19.25 24.25 19.6 24.25 20.03Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75 24.7498H27.05C27.44 24.7498 27.75 24.3998 27.75 23.9698C27.75 23.4298 27.6 23.3498 27.26 23.2298L26.75 23.0498V24.7498Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.58 15.48L31.53 17.53C31.38 17.68 31.19 17.75 31 17.75C30.81 17.75 30.62 17.68 30.47 17.53C30.18 17.24 30.18 16.76 30.47 16.47L32.52 14.42C30.76 12.92 28.49 12 26 12C20.48 12 16 16.48 16 22C16 27.52 20.48 32 26 32C31.52 32 36 27.52 36 22C36 19.51 35.08 17.24 33.58 15.48ZM27.75 21.82C28.39 22.05 29.25 22.51 29.25 23.98C29.25 25.23 28.26 26.26 27.05 26.26H26.75V26.51C26.75 26.92 26.41 27.26 26 27.26C25.59 27.26 25.25 26.92 25.25 26.51V26.26H25.17C23.84 26.26 22.75 25.14 22.75 23.76C22.75 23.34 23.09 23 23.5 23C23.91 23 24.25 23.34 24.25 23.75C24.25 24.3 24.66 24.75 25.17 24.75H25.25V22.53L24.25 22.18C23.61 21.95 22.75 21.49 22.75 20.02C22.75 18.77 23.74 17.74 24.95 17.74H25.25V17.5C25.25 17.09 25.59 16.75 26 16.75C26.41 16.75 26.75 17.09 26.75 17.5V17.75H26.83C28.16 17.75 29.25 18.87 29.25 20.25C29.25 20.66 28.91 21 28.5 21C28.09 21 27.75 20.66 27.75 20.25C27.75 19.7 27.34 19.25 26.83 19.25H26.75V21.47L27.75 21.82Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.69 11.71C36.61 11.53 36.47 11.38 36.28 11.3C36.19 11.27 36.1 11.25 36 11.25H32C31.59 11.25 31.25 11.59 31.25 12C31.25 12.41 31.59 12.75 32 12.75H34.19L32.52 14.42C32.9 14.75 33.25 15.1 33.58 15.48L35.25 13.81V16C35.25 16.41 35.59 16.75 36 16.75C36.41 16.75 36.75 16.41 36.75 16V12C36.75 11.9 36.73 11.81 36.69 11.71Z",
    fill: "#5ED5A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_7569",
    x: 0,
    y: 0.25,
    width: 52.75,
    height: 52.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.835294 0 0 0 0 0.658824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_7569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_7569",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTradesActive);
export default __webpack_public_path__ + "static/media/navTradesActive.10a6027a3c47b24c622ed4526d3efd41.svg";
export { ForwardRef as ReactComponent };